// Module
var code = `<tft-dialog ng-repeat="dialogOptions in dialogPlaceholderCtrl.modalDialogs" dialog-options="dialogOptions" on-close="dialogPlaceholderCtrl.removeDialog(dialogOptions)"> </tft-dialog>`;
// Exports
export default code;